import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import DataStore from '../support/DataStore';

const dataStore = DataStore.getInstance('app');

const httpLink = createHttpLink({
  uri: '/graphql',
});

const authLink = setContext((_, { headers }) => {
  let account = dataStore.get('account');
  let token = account?.token;
  let newHeaders = token ? { ...headers, 'X-Auth-Token': token } : headers;
  return {
    headers: newHeaders,
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      MarketSelection: {
        keyFields: false,
      },
      SignupFormDefinition: {
        keyFields: false,
      },
    },
  }),
});
